<!--
 * @Author: zyy
 * @Date: 2023-03-13 10:54:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-18 15:09:01
 * @Description: default
-->


<template>
    <div class="flex">
        <div class="tpl-box">
            <div class="swiper-box border" :class="{ 'border-active': currentTpl == 1 }" @click="handleCurrent(1)"
                v-if="form.swiperList.length > 0">
                <img :src="form.swiperList[0].url">
            </div>
            <div class="nav-box border" :class="{ 'border-active': currentTpl == 2 }" @click="handleCurrent(2)"
                v-if="form.navList.length > 0">
                <div class="nav-item" v-for="item in form.navList" :key="item.id">
                    <img :src="item.url">
                    <div>{{ item.name }}</div>
                </div>
            </div>
            <div class="goods-list border" :class="{ 'border-active': currentTpl == 3 }" @click="handleCurrent(3)"
                v-if="form.goodsList.length > 0">
                <div class="goods-item" v-for="item in form.goodsList" :key="item.id">
                    <img :src="item.image">
                    <div class="textline-2" style="margin-top: 5px;">{{ item.title }}</div>
                </div>
            </div>
        </div>

        <div class="params-box" v-show="currentTpl == 1">
            <div class="leading-6">积分首页轮播图</div>
            <div class="leading-6">图片设置</div>
            <div class="">
                <div v-for="(item, index) in form.swiperList" :key="item.id" class="flex items-center box-bg mb-2 relative"
                    @mouseenter="swiperMouseenter(index)" @mouseleave="cancelShow = false">
                    <a-upload name="mediaGoods" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl"
                        class="app-avatar-uploader" :before-upload="$beforeUpload"
                        @change="handleUpload($event, index, 'swiperList')" v-model="item.url">
                        <dy-image :src="item.url" v-if="item.url" preview></dy-image>
                        <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
                    </a-upload>
                    <div class="flex-1 ml-2">
                        <div class="flex items-center leading-6">
                            <div class="item-label">图片名称</div>
                            <a-input v-model="item.name" placeholder="请输入图片名称"></a-input>
                        </div>
                        <div class="flex items-center leading-6">
                            <div class="item-label">图片链接</div>
                            <!-- <a-input v-model="item.link" placeholder="请输入图片链接"></a-input> -->
                            <a-cascader :options="linkData" placeholder="请选择链接" @change="onChange($event, item)"
                                v-model="item.link_id" />
                        </div>
                    </div>

                    <div class="cancel-box " :class="{ none: !(currentItem === index && cancelShow) }"
                        @click="handelDelItem(item, 'swiperList')">x</div>
                </div>
                <div class="leading-6">
                    <a-button type="primary" @click="addItem('swiperList')">添加图片</a-button>
                </div>
            </div>

        </div>

        <div class="params-box" v-show="currentTpl == 2">
            <div class="leading-6">首页导航</div>
            <div class="leading-6">图文设置</div>
            <div class="">
                <div v-for="(item, index) in form.navList" :key="item.id" class="flex items-center box-bg mb-2 relative"
                    @mouseenter="swiperMouseenter(index)" @mouseleave="cancelShow = false">
                    <a-upload name="mediaGoods" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl"
                        class="app-avatar-uploader" :before-upload="$beforeUpload"
                        @change="handleUpload($event, index, 'navList')" v-model="item.url">
                        <dy-image :src="item.url" v-if="item.url" preview></dy-image>
                        <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
                    </a-upload>
                    <div class="flex-1 ml-2">
                        <div class="flex items-center leading-6">
                            <div class="item-label">导航名称</div>
                            <a-input v-model="item.name" placeholder="请输入图片名称" :maxLength="4"></a-input>
                        </div>
                        <div class="flex items-center leading-6">
                            <div class="item-label">导航链接</div>
                            <!-- <a-input v-model="item.link" placeholder="请输入图片链接"></a-input> -->
                            <a-cascader :options="linkData" placeholder="请选择链接" @change="onChange($event, item)"
                                v-model="item.link_id" />
                        </div>
                    </div>

                    <div class="cancel-box " :class="{ none: !(currentItem === index && cancelShow) }"
                        @click="handelDelItem(item, 'navList')">x</div>
                </div>
                <div class="leading-6">
                    <a-button type="primary" @click="addItem('navList')">添加导航</a-button>
                </div>
            </div>

        </div>

        <div class="params-box" v-show="currentTpl == 3">
            <div class="leading-6">商品列表</div>
            <div class="leading-6">商品设置</div>
            <div class="">
                <div v-for="(item, index) in form.goodsList" :key="item.id" class="flex items-center box-bg mb-2 relative"
                    @mouseenter="swiperMouseenter(index)" @mouseleave="cancelShow = false">
                    <dy-image :src="item.image" v-if="item.image" preview style="width:100px;height:100px"></dy-image>
                    <div class="flex-1 ml-2">
                        <div class="flex items-center leading-6">
                            <div class="item-label">商品名称</div>
                            <a-input v-model="item.title" disabled></a-input>
                        </div>
                    </div>

                    <div class="cancel-box " :class="{ none: !(currentItem === index && cancelShow) }"
                        @click="handelDelItem(item, 'goodsList')">x</div>
                </div>
                <div class="leading-6">
                    <a-button type="primary" @click="addGoods()">添加商品</a-button>
                </div>
            </div>

        </div>

        <div>
            <a-button type="primary" class="ml-2" @click="submit">提交</a-button>
        </div>
        <a-modal title="选择商品" :confirm-loading="goodsModal.loading" v-model="goodsModal.show" @ok="confirmGoodsModal"
            destroy-on-close centered :width="1000">
            <a-form-model>
                <a-form-model-item label="选择商品">
                    <a-select placeholder="选择商品" v-model="goodsModal.data">
                        <a-select-option :value="value.id" v-for="value in goodsModal.goodsList" :key="value.id">{{
                            value.title }}</a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>
  
<script>
import { generateUUID } from '@/plugins/utils.js'
import FitmentService from '@/io/goods/fitment.js'
import integralGoodsService from "@/io/goods/integralGoods.js";
import GoodsTypeService from '@/io/goods_type.js'
import GoodsListService from '@/io/goods_list.js'
import IntergralGoodsService from '@/io/goods/integralGoods.js'

export default {

    data() {
        return {
            currentTpl: 1,
            currentItem: 0,
            cancelShow: false,
            avatar: {
                goodsLoading: false,
                bannerLoading: false,
            },
            goodsModal: {
                loading: false,
                show: false,
                goodsList: [],
                data: undefined
            },
            form: {
                swiperList: [{
                    id: generateUUID(),
                    name: '轮播图',
                    url: 'https://tjsqdnk-cos-1313451212.cos.ap-guangzhou.myqcloud.com/attachments/images/202303/13/cIidJkXiBbPVH6odkd0QYKa8ZIhKxuDyrjCNpNXF.jpeg',
                    link: '',
                    link_id: []
                }],
                navList: [{
                    id: generateUUID(),
                    name: '商品列表',
                    url: 'https://tjsqdnk-cos-1313451212.cos.ap-guangzhou.myqcloud.com/attachments/images/202303/13/L6oC92awq9yFt7cmKO4tlF96v0GqNVj6oQXzoQAV.jpeg',
                    link: '',
                    link_id: []
                }],
                goodsList: []
            },
            linkData: []
        };
    },
    mounted() {
        this.getGoodsList()
        this.getDetail()
        this.getLinkData()
    },
    methods: {
        onChange(value, item) {
            item.link = `${this.linkData[value[0]].url}?id=${value[1]}${value[0] === 2 ? '&type=score' : ''}`
        },
        async getLinkData() {
            const goodsList = (await GoodsListService.list({ page: 1 })).data.rows.map(val => ({ value: val.id, label: val.title }))
            const goodsTypeList = (await GoodsTypeService.list(1)).data.rows.map(val => ({ value: val.id, label: val.name }))
            const integralGoodsList = (await IntergralGoodsService.list({ page: 1 })).data.rows.map(val => ({ value: val.id, label: val.title }))

            this.linkData.push({ value: 0, label: '商品分类', children: goodsTypeList, url: '/pages/goods/list' })
            this.linkData.push({ value: 1, label: '商品列表', children: goodsList, url: '/pages/goods/detail' })
            this.linkData.push({ value: 2, label: '积分商品列表', children: integralGoodsList, url: '/pages/goods/detail' })
        },
        getDetail() {
            FitmentService.info({ id: 1 }).then(res => this.form = JSON.parse(res.data.value))
        },
        submit() {
            FitmentService.submit({
                id: 1,
                value: JSON.stringify(this.form),
                key: 'score_shop'
            }).then(res => {
                this.$message.success('提交成功')
            })
        },
        addGoods() {
            this.goodsModal.show = true
        },
        confirmGoodsModal() {
            if (this.goodsModal.data) {
                this.form.goodsList.push(this.goodsModal.goodsList.find(val => val.id === this.goodsModal.data))
                this.goodsModal.goodsList = this.goodsModal.goodsList.filter(val => {
                    return !this.form.goodsList.some(item => item.id === val.id)
                })
                this.goodsModal.data = undefined
                this.goodsModal.show = false
            } else {
                this.$message.error('请选择商品')
            }
        },
        handleCurrent(index) {
            this.currentTpl = index
        },

        // 获取商品列表
        getGoodsList() {
            integralGoodsService.list({
                page: 1,
                limit: 100
            }).then(res => {
                this.goodsModal.goodsList = res.data.rows
                // this.goodsModal.goodsList = res.data.rows.map(val => {
                //     return {
                //         id: val.id,
                //         title: val.title,
                //         image: val.image
                //     }
                // })
                this.goodsModal.goodsList = this.goodsModal.goodsList.filter(val => {
                    return !this.form.goodsList.some(item => item.id === val.id)
                })
            })
        },
        // 上传商品图片
        handleUpload(info, index, dataName) {
            let status = info.file.status;
            if (status) {
                if (status === "done") {
                    this.avatar.goodsLoading = false;
                    this.form[dataName][index].url = info.file.response.mediaGoods
                } else if (status === "error") {
                    this.$message.error(info.file.response.message)
                } else {
                    this.avatar.goodsLoading = true;
                }
            }
        },
        addItem(name) {
            this.form[name].push({
                id: generateUUID(),
                name: '标题',
                url: 'https://tjsqdnk-cos-1313451212.cos.ap-guangzhou.myqcloud.com/attachments/images/202303/13/X3fH0QPnw2dFtcf9ZOrHUeIXYGGk50M0g5AlyGY8.png',
                link: ''
            })
        },
        swiperMouseenter(index) {
            this.currentItem = index
            this.cancelShow = true
        },
        handelDelItem(item, name) {
            const { id } = item
            if (this.form[name].length > 1) {
                this.form[name].forEach((val, index) => {
                    if (val.id === id) this.form[name].splice(index, 1)
                })

                if (name === 'goodsList') this.goodsModal.goodsList.push(item)

            } else {
                this.$message.error('最少保留一张图片')
            }
        }
    },
};
</script>
<style scoped lang="less">
.tpl-box {
    width: 377px;
    max-height: 850px;
    min-height: 850px;
    overflow: hidden;
    overflow-y: auto;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    background-color: #fdfdfd;

    // padding: 10px 0;
    .swiper-box {
        cursor: pointer;
        width: 100%;
        height: 180px;

        img {
            width: 375px;
            height: 180px;
            object-fit: cover;
        }
    }

    .nav-box {
        cursor: pointer;
        display: flex;
        flex-wrap: wrap;
        width: 375px;

        .nav-item {
            width: 25%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            padding: 10px 15px;

            img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
            }

            div {
                font-size: 14px;
                line-height: 40px;
            }
        }
    }

    // .nav-box::-webkit-scrollbar {
    //     display: none;
    // }

    .goods-list {
        cursor: pointer;
        padding: 20px;
        display: flex;
        flex-wrap: wrap;

        .goods-item {
            width: 160px;

            img {
                width: 160px;
                height: 160px;
                border-radius: 16px 16px 0 0;
            }
        }

        .goods-item:nth-child(2n+1) {
            margin-right: 15px;
        }

    }

}

.tpl-box::-webkit-scrollbar {
    display: none;
}

.border {
    border: 1px dashed rgb(200, 200, 200);
}

.border-active {
    border: 1px solid rgb(55, 138, 202);
}

.params-box {
    margin-left: 50px;
    padding: 10px;
}

.box-bg {
    background-color: #f7f7f7;
    border-radius: 2px;
    width: 400px;
    height: 130px;
    padding: 0 10px;
}

.item-label {
    width: 100px;
}

.cancel-box {
    position: absolute;
    right: -10px;
    top: -10px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #c7c7c7;
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
    font-size: 12px;
}

/deep/ .ant-upload-picture-card-wrapper {
    width: 100px;
}
</style>
  